module.exports = __webpack_public_path__ + "img/interreg-icon.40d2ba39.png";